/** All dropdowns on the page */
const dropdowns = document.querySelectorAll(".navbar .links .dropdown");

/**
 * Hides all dropdowns except one
 * @param exception the dropdown element
 */
function hideAllExcept(exception: Element): void {
	dropdowns.forEach((dropdown) => {
		if (dropdown == exception) return;

		dropdown.classList.toggle("show", false);
	});
}

dropdowns.forEach((dropdown: Element) => {
	dropdown.addEventListener("click", () => {
		// hide all dropdowns when one is clicked
		hideAllExcept(dropdown);

		// only show the clicked dropdown
		dropdown.classList.toggle("show");
	});

	// allow dropdowns to be hovered, and have it separate from clicked visibility
	dropdown.addEventListener("mouseenter", () => {
		dropdown.classList.toggle("hover", true);
	});

	// remove hover visibility after a timeout to prevent annoyances
	dropdown.addEventListener("mouseleave", () => {
		setTimeout(() => dropdown.classList.toggle("hover", false), 150);
	});
});
